export const TYPE_LICENSE = {
  DEMO: 'DEMO',
}

export const TYPES_BOOK_STATUS = {
  ACCESSIBLE: 'ACCESSIBLE',
  FINISHED: 'FINISHED',
  NOT_ACCESSIBLE: 'NOT_ACCESSIBLE',
  NOT_VISIBLE: 'NOT_VISIBLE',
}

export const BOOK_STATUS_TEXT = {
  [TYPES_BOOK_STATUS.ACCESSIBLE]: 'En proceso de edición',
  [TYPES_BOOK_STATUS.NOT_ACCESSIBLE]: 'Próximamente',
}

export const TYPES_BOOK_UNITS_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
}

export const TYPES_EXCEPTION = {
  SCHOOL_MEMBER_ALREADY_HAS_BOOK: 'SchoolMemberAlreadyHasBookException',
}

export const TYPES_GRADE_ALGORITHM = {
  AVERAGE_OF_N: 'AVERAGE_OF_N',
  BEST_ATTEMPT: 'BEST_ATTEMPT',
  LAST_ATTEMPT: 'LAST_ATTEMPT',
}

export const EDUCATION_LAW = {
  LOE: 'LOE',
  LOMCE: 'LOMCE',
  LOMLOE: 'LOMLOE',
}

export const TYPES_BOOK_COLLECTIONS = {
  COMUNIDAD_EN_RED: 'COMUNIDAD_EN_RED',
  PRISMA: 'PRISMA',
}
